import React, { createContext } from "react";

import EditPopup from "./EditPopup";

const editPopup = ({
    title,
    icon,
    editor,
    value,
    onChange,
    btnText,
    btnCallback,
    activity = false,
    characterCount = null,
    defaultStepper = true,
    isOpenPopup = true,
    disabled,
    data,
    setData,
    dueDate,
    duplicateWOCheck,
    selectedReason,
    questionType,
}) => (
    <EditPopup
        title={title}
        icon={icon}
        content={editor({
            value,
            onChange,
        })}
        btnText={btnText}
        btnCallback={btnCallback}
        activity={activity}
        characterCount={characterCount}
        isOpenPopup={isOpenPopup}
        disabled={disabled}
        defaultStepper={defaultStepper}
        data={data}
        setData={setData}
        dueDate={dueDate}
        duplicateWOCheck={duplicateWOCheck}
        selectedReason={selectedReason}
        questionType={questionType}
    />
);

export const FormContext = createContext();

export const Form = (props) => {
    const editors = [];
    const addEditor = (editorProps) => {
        const editor = editPopup(editorProps);
        editors.push(editor);
        // setEditors([...editors, editor])

        return editor;
    };

    const ctx = {
        value: props.value,
        edit: addEditor,
    };

    return (
        <FormContext.Provider value={ctx}>
            <form style={{ marginBottom: "70px" }}>{props.children}</form>
        </FormContext.Provider>
    );
};
